import { useDispatch } from 'react-redux';
import { ParamsCtx } from './paramsCtx';
import { useCallback, useContext, useEffect } from 'react';

export function useDispatchParams(action) {
  const dispatch = useDispatch();
  const { queryParams, isLoadingParams } = useContext(ParamsCtx);

  const load = useCallback(() => {
    dispatch(action(queryParams));
  }, [action, queryParams, dispatch]);

  useEffect(() => {
    if (!isLoadingParams) {
      load();
    }
  }, [load, isLoadingParams]);

  return load;
}
